@if(activeModal) {
  <div class="modal-header">
    @if (this.data?.mode == 'new') {
      <h5 class="modal-title">Add New Product</h5>
    }
       @if (this.data?.mode == 'clone') {
      <h5 class="modal-title">Clone Product</h5>
    }
       @if (this.data?.mode == 'update') {
      <h5 class="modal-title">Update Product</h5>
    }
    <button type="button" class="btn-close ms-auto" (click)="closeModal()"></button>
  </div>
}
<!-- main content start -->
<div class="main-content" [ngClass]="{'modal-body bg-light':activeModal}">
  <form [formGroup]="productMultipleOptionForm" (ngSubmit)="submitProductMultipleOptionForm()">
    <div class="breadcrumb mb-30">
      <!-- {{isUpdateproduct}} -->
      <div class="btn-box">
        @if (!activeModal) {
          <h2>Add New Product</h2>
        }
        <!-- <a href="all-product.html" class="btn btn-sm btn-primary">View All</a> -->
      </div>
    </div>
    <div class="row g-4">
      <div class="col-xxl-9 col-lg-8">
        <form [formGroup]="productDetails" (ngSubmit)="addProductDetails()">
          <div class="panel mb-30">
            <div class="panel-body product-title-input">
              <div class="row g-3 mb-3">
                <div class="col-md-8">
                  <label class="form-label">Product Title</label>
                  <input type="text" formControlName="productTitle" class="form-control" id="productTitle"
                    placeholder="Title for product"
                    [class.is-invalid]="addProductDetailsValidation['productTitle'].touched && addProductDetailsValidation['productTitle'].invalid"
                     (change)="createPermalink()">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Product Type</label>
                  <select class="form-select" [(ngModel)]="productType" [ngModelOptions]="{standalone: true}">
                    <option value="simple">Simple Product</option>
                    <option value="variable">Variable Product</option>
                  </select>
                </div>
              </div>
              @if (addProductDetailsValidation['productTitle'].touched &&
              addProductDetailsValidation['productTitle'].errors?.['required']) {
              <div class="text-danger fs-12 mt-1">
                Product title is required.
              </div>
              }
              <p class="perma-txt">
                Permalink: {{domain}}/<span [attr.contenteditable]="isInputShow" [class.border]="isInputShow"
                  [class.border-primary]="isInputShow" [class.px-1]="isInputShow" class="site-link text-primary"
                  id="productPermalink" (blur)="onPermalinkBlur($event)">{{permaLink}}</span>
                <span class="float-end">
                  <button type="button" class="btn-flush bg-primary" (click)="enableInput()"
                    [hidden]="isInputShow">Edit</button>
                  <button type="button" class="btn-flush bg-success me-2" id="createPerma"
                    (click)="permalinkAction('done')" [hidden]="!isInputShow">OK</button>
                  <button type="button" class="btn-flush bg-danger" id="cancelPerma" (click)="permalinkAction('cancel')"
                    [hidden]="!isInputShow">Cancel</button>
                </span>
              </p>
            </div>
          </div>
          <div class="panel mb-30">
            <div class="panel-header">
              <h5>Short Description</h5>
              <div class="btn-box d-flex gap-2 align-items-center">
                <button type="button" class="btn btn-sm" 
                  [ngClass]="elementorMode.shortDescription ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="openElementorBuilder('shortDescription', elementorModal)">
                  <i class="fa fa-cubes me-1"></i> Visual Builder
                </button>
                <button class="btn btn-sm btn-icon btn-outline-primary"><i class="fa fa-arrows-rotate"></i></button>
                <button class="btn btn-sm btn-icon btn-outline-primary panel-close"><i
                    class="fa fa-angle-up"></i></button>
              </div>
            </div>
            <div class="panel-body">
              @if (elementorMode.shortDescription) {
                <div class="elementor-preview-container position-relative border rounded bg-light p-3 mb-2" (click)="openElementorBuilder('shortDescription', elementorModal)">
                  <div [innerHTML]="getSafeHtml(productDetails.get('shortDescription')?.value)" class="elementor-content-preview"></div>
                  <div class="elementor-edit-overlay">
                    <button type="button" class="btn btn-primary btn-sm">
                      <i class="fa fa-cubes me-1"></i> Edit with Visual Builder
                    </button>
                  </div>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-link btn-sm text-muted p-0" (click)="elementorMode.shortDescription = false">
                    Switch to Standard Editor
                  </button>
                </div>
              } @else {
                <div class="editor-container">
                  <ce-custom-editor
                    formControlName="shortDescription"
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                </div>
              }
            </div>
          </div>

          <div class="panel mb-30">
            <div class="panel-header">
              <h5>Features</h5>
              <div class="btn-box d-flex gap-2 align-items-center">
                <button type="button" class="btn btn-sm" 
                  [ngClass]="elementorMode.features ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="openElementorBuilder('features', elementorModal)">
                  <i class="fa fa-cubes me-1"></i> Visual Builder
                </button>
              </div>
            </div>
            <div class="panel-body">
              @if (elementorMode.features) {
                <div class="elementor-preview-container position-relative border rounded bg-light p-3 mb-2" (click)="openElementorBuilder('features', elementorModal)">
                  <div [innerHTML]="getSafeHtml(productDetails.get('features')?.value)" class="elementor-content-preview"></div>
                  <div class="elementor-edit-overlay">
                    <button type="button" class="btn btn-primary btn-sm">
                      <i class="fa fa-cubes me-1"></i> Edit with Visual Builder
                    </button>
                  </div>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-link btn-sm text-muted p-0" (click)="elementorMode.features = false">
                    Switch to Standard Editor
                  </button>
                </div>
              } @else {
                <div class="editor-container">
                  <ce-custom-editor
                    formControlName="features"
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                </div>
              }
            </div>
          </div>

          <div class="panel mb-30">
            <div class="panel-header">
              <h5>Product Description</h5>
              <div class="btn-box d-flex gap-2 align-items-center">
                <button type="button" class="btn btn-sm" 
                  [ngClass]="elementorMode.productDescription ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="openElementorBuilder('productDescription', elementorModal)">
                  <i class="fa fa-cubes me-1"></i> Visual Builder
                </button>
                <button class="btn btn-sm btn-icon btn-outline-primary"><i class="fa fa-arrows-rotate"></i></button>
                <button class="btn btn-sm btn-icon btn-outline-primary panel-close"><i
                    class="fa fa-angle-up"></i></button>
              </div>
            </div>
            <div class="panel-body">
               <div class="d-flex justify-content-end mb-2">
                <!-- <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="openHtmlEditor('productDescription')">
                  Edit HTML
                </button> -->
              </div>

              @if (elementorMode.productDescription) {
                <div class="elementor-preview-container position-relative border rounded bg-light p-3 mb-2" (click)="openElementorBuilder('productDescription', elementorModal)">
                  <div [innerHTML]="getSafeHtml(productDetails.get('productDescription')?.value)" class="elementor-content-preview"></div>
                  <div class="elementor-edit-overlay">
                    <button type="button" class="btn btn-primary btn-sm">
                      <i class="fa fa-cubes me-1"></i> Edit with Visual Builder
                    </button>
                  </div>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-link btn-sm text-muted p-0" (click)="elementorMode.productDescription = false">
                    Switch to Standard Editor
                  </button>
                </div>
              } @else {
                <div class="editor-container">
                  <ce-custom-editor
                    formControlName="productDescription"
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                </div>
              }



              <!-- <quill-editor #productDescriptionQuill formControlName="productDescription" [modules]="modulesNoImage"></quill-editor> -->
            </div>
          </div>

          <div class="panel mb-30">
            <div class="panel-body">
              <label for="pstatus" class="form-label">Product Status*</label>
              <!-- <select size="4" id="pstatus" class="form-select" formControlName="productStatus">
                @for(item of productStatus; track $index){
                <option [value]="item">{{item}}</option>
                }
              </select> -->
              <div class="d-flex flex-column gap-2">
                @for (key of productStatus; track $index) {
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [checked]="key.isActive"
                    (change)="onStatusChange($index, $event)" id="status{{$index}}">

                  <label class="form-check-label" for="status{{$index}}">
                    {{ key.label }}
                  </label>
                </div>
                }


              </div>


              <!-- @if (hasError('country', 'required')) {
                                  <small class="text-danger">Country is required</small>
                                  } -->
            </div>
          </div>
        </form>
     <!-- HTML EDIT MODAL -->
           @if (showHtmlEditor) {

          <div class="modal-backdrop fade show"></div>

<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit HTML</h5>
         <button
  type="button"
  class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
  (click)="toggleTheme()">

  <i
    class="fa"
    [ngClass]="editorTheme === 'light' ? 'fa-moon' : 'fa-sun'"
    aria-hidden="true">
  </i>

  {{ editorTheme === 'light' ? 'Dark Mode' : 'Light Mode' }}
</button>

        <button type="button" class="btn-close" (click)="closeHtmlEditor()"></button>
      </div>

      <div class="modal-body">
        <textarea
          class="form-control html-editor-textarea"
          rows="15"
          [formControl]="htmlControl"
          [ngClass]="editorTheme"
          >
        </textarea>
      </div>

      <div class="modal-footer gap-2">
        <button class="btn btn-secondary" (click)="closeHtmlEditor()">Cancel</button>
        <button class="btn btn-primary" (click)="saveHtml()">Save</button>
      </div>
    </div>
  </div>
</div>

           }
        <div class="panel mb-30">
          <form [formGroup]="productOptionData" (ngSubmit)="productOptionType()">
            <div class="panel-header">
              <h5>Product Detail</h5>
              <div class="panel-header-right">
                @if(false){

                <div class="form-check d-flex gap-4">
                  <div class="form-check">
                    <input class="form-check-input" formControlName="generalProductData" type="checkbox" value=""
                      id="generalProductData">
                    <label class="form-check-label" for="generalProductData">
                      General
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" formControlName="downloadableProductData" type="checkbox" value=""
                      id="DownloadableProductData">
                    <label class="form-check-label" for="DownloadableProductData">
                      Downloadable
                    </label>
                  </div>
                </div>
                }
              </div>
              <div class="btn-box d-flex gap-2">
                <button class="btn btn-sm btn-icon btn-outline-primary"><i class="fa fa-arrows-rotate"></i></button>
                <button class="btn btn-sm btn-icon btn-outline-primary panel-close"><i
                    class="fa fa-angle-up"></i></button>
              </div>
            </div>
          </form>

          <div class="panel-body">
            <nav>
              <div class="btn-box d-flex flex-wrap gap-1 mb-30" id="nav-tab" role="tablist">
                <button class="btn btn-sm btn-outline-primary active" id="nav-media-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-media" type="button" role="tab" aria-controls="nav-media"
                  aria-selected="true">Media</button>
                <button class="btn btn-sm btn-outline-primary" id="nav-inventory-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-inventory" type="button" role="tab" aria-controls="nav-inventory"
                  aria-selected="false">Inventory</button>
                <button class="btn btn-sm btn-outline-primary" id="nav-price-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-price" type="button" role="tab" aria-controls="nav-price"
                  aria-selected="false">Price</button>
                <button class="btn btn-sm btn-outline-primary" id="nav-attribute-tab" data-bs-toggle="tab" 
                  data-bs-target="#nav-attribute" type="button" role="tab" aria-controls="nav-attribute" (click)="productType = 'variable'"
                  aria-selected="false">Attributes</button>
                <button class="btn btn-sm btn-outline-primary" id="nav-shipping-info-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-shipping-info" type="button" role="tab" aria-controls="nav-shipping-info"
                  aria-selected="false">Shipping info</button>
                <!-- <button class="btn btn-sm btn-outline-primary" id="nav-video-tab" data-bs-toggle="tab" data-bs-target="#nav-video" type="button" role="tab" aria-controls="nav-video" aria-selected="false">Video</button> -->
                <button class="btn btn-sm btn-outline-primary" id="nav-shipping-configuration-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-shipping-configuration" type="button" role="tab"
                  aria-controls="nav-shipping-configuration" aria-selected="false">Shipping Configuration</button>
                <button class="btn btn-sm btn-outline-primary" id="nav-offer-tab" data-bs-toggle="tab"
                  data-bs-target="#nav-offer" type="button" role="tab" aria-controls="nav-offer"
                  aria-selected="false">Offer</button>
              </div>
              
            </nav>

            <div class="tab-content product-data-tab" id="nav-tabContent">
              <!-- Media Tab -->
              <div class="tab-pane fade show active" id="nav-media" role="tabpanel" aria-labelledby="nav-media-tab"
                tabindex="0">
                <form [formGroup]="productMediaSection">
                  <div class="row">
                    <div class="col-12">
                      <div class="add-thumbnail product-image-upload">
                        <div class="part-txt">
                          <h5>Main Image:
                            <span>Upload a square image required (1:1 aspect ratio) — recommended size: 400 × 400
                              px.(jpeg/png/webp)</span>
                          </h5>
                        </div>
                        <input type="file" class="form-control" formControlName="thumbUpload" accept="image/*"
                          (change)="onFileSelectThumb($event)">
                        @if(thumbPreview!=''){
                        <img [src]="thumbPreview" class="preview-img rounded mt-1" />
                        }
                      </div>
                    </div>
                    <div class="col-12 mt-4">
                      <div class="add-gallery-img product-image-upload">
                        <div class="part-txt">
                          <h5>Add gallery: <span>Upload a square image required (1:1 aspect ratio) — recommended size:
                              400 × 400 px.(jpeg/png/webp)</span></h5>
                        </div>

                        <input #galleryInput multiple type="file" class="form-control" formControlName="galleryUpload"
                          accept="image/*" (change)="onFileSelect($event)">
                        <div class="d-flex flex-nowrap gap-2 overflow-x-auto mt-2">
                          @for (item of thumbGallery; track $index) {
                          <div class="position-relative">
                            <img [src]="item" class="preview-img rounded"
                              style="width: 100px; height: 100px; object-fit: cover;" />
                            <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
                              style="padding: 2px 6px; font-size: 12px;" (click)="removeGalleryImage($index)">
                              <i class="fa fa-xmark"></i>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="false">
                      <hr>
  
                      <h5>Product Description Images <span>(jpeg/png)</span></h5>
                      <form [formGroup]="productDetails">
                        <div class="d-flex justify-content-end mb-2">
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    (click)="openHtmlEditor('productDescriptionImageGallery')">
                    Edit HTML
                  </button> -->
                </div>
  
                <div class="editor-container">
                  <ce-custom-editor
                    formControlName="productDescriptionImageGallery"
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                </div>
  
                        <!-- <quill-editor #descriptionImageGallery formControlName="productDescriptionImageGallery"
                          [modules]="modulesWithImage"></quill-editor> -->
                      </form>
                    </ng-container>

                    <!-- <div class="panel mb-30">
                      <div class="panel-header">
                        <div class="btn-box d-flex gap-2">
                <button class="btn btn-sm btn-icon btn-outline-primary"><i class="fa fa-arrows-rotate"></i></button>
                <button class="btn btn-sm btn-icon btn-outline-primary panel-close"><i
                    class="fa fa-angle-up"></i></button>
              </div>
                      </div>
                      <div class="panel-body">
                      </div>
                    </div>
                    <div class="col-12 mt-4">
                      <div class="add-gallery-img product-image-upload">
                        <div class="part-txt">
                          <h5>Product Description Images <span>(jpeg/png)</span></h5>
                        </div>

                        <input #descriptionImageGallery multiple type="file" class="form-control" formControlName="productDescriptionImageGallery"
                          accept="image/*" (change)="onFileProductDescriptionGallery($event)">
                        <div class="d-flex flex-nowrap gap-2 overflow-x-auto mt-2">
                          @for (item of prodDescriptionImageGallery; track $index) {
                          <div class="position-relative">
                            <img [src]="item" class="preview-img rounded"
                              style="width: 100px; height: 100px; object-fit: cover;" />
                            <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
                              style="padding: 2px 6px; font-size: 12px;" (click)="removeProductDescriptionGalleryImage($index)">
                              <i class="fa fa-xmark"></i>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                    </div> -->
                  </div>
                </form>
              </div>

              <!-- Inventory Tab -->
              <div class="tab-pane fade" id="nav-inventory" role="tabpanel" aria-labelledby="nav-inventory-tab"
                tabindex="0">
                <form [formGroup]="productInventrySection">
                  <div class="row align-items-center g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">SKU <span class="btn-flush fs-14"
                        data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <input type="text" class="form-control form-control-sm" formControlName="sku" id="SKU">
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Manage Stock?</label>
                    <div class="col-md-10">
                      <div class="form-check">
                        <input class="form-control form-control-sm" type="number" formControlName="manageStock"
                          id="manageStock">
                        <!-- <label class="form-check-label" for="manageStock">
                          Manage stock level (quantity)
                        </label> -->
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Stock Status <span class="btn-flush fs-14"
                        data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <select class="form-control form-control-sm" formControlName="stockStatus">
                        <option value="0">In stock</option>
                        <option value="1">Out of stock</option>
                        <option value="2">On backorder</option>
                      </select>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Sold individually <span
                        class="btn-flush fs-14" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="soldIndividually"
                          id="soldIndividually">
                        <label class="form-check-label" for="soldIndividually">
                          Limit purchases to 1 item per order
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Product Code <span class="btn-flush fs-14"
                        data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <input type="text" class="form-control form-control-sm" formControlName="productCode"
                        id="productCode">
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label for="lowStockWarning" class="col-md-2 col-form-label col-form-label-sm">Low Stock
                      Warning</label>
                    <div class="col-md-10">
                      <input type="number" class="form-control form-control-sm" formControlName="lowStockWarning"
                        id="lowStockWarning">
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label for="showStockQuantity" class="col-md-2 col-8 col-form-label col-form-label-sm">Show Stock
                      Quantity</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="showStockQuantity"
                          id="showStockQuantity">
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row align-items-center g-3 mb-3">
                    <label for="showStockWithText" class="col-md-2 col-8 col-form-label col-form-label-sm">Show Stock
                      With Text</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="showStockWithText"
                          id="showStockWithText">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3">
                    <label for="hideStock" class="col-md-2 col-8 col-form-label col-form-label-sm">Hide Stock</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="hideStock" id="hideStock">
                      </div>
                    </div>
                  </div> -->
                </form>
              </div>

              <!-- Price Tab -->
              <div class="tab-pane fade" id="nav-price" role="tabpanel" aria-labelledby="nav-price-tab" tabindex="0">
                <form [formGroup]="priceSection">
                  <div class="row g-3 mb-3">
                    <label for="regularPrice" class="col-md-2 col-form-label col-form-label-sm">Regular Price
                      (₹)*</label>
                    <div class="col-md-10">
                      <input type="number" class="form-control form-control-sm" formControlName="regularPrice"
                        [class.is-invalid]="priceSection.get('regularPrice')?.touched && priceSection.get('regularPrice')?.invalid"
                        (blur)="discountPriceChange()">
                      @if (priceSection.get('regularPrice')?.touched &&
                      priceSection.get('regularPrice')?.errors?.['required']) {
                      <div class="text-danger fs-12 mt-1">
                        Regular price is required.
                      </div>
                      }
                      @if (priceSection.get('regularPrice')?.touched &&
                      priceSection.get('regularPrice')?.errors?.['min']) {
                      <div class="text-danger fs-12 mt-1">
                        Regular price must be greater than 0.
                      </div>
                      }
                    </div>
                  </div>
                  <div class="row g-3 mb-3">
                    <label for="salePrice" class="col-md-2 col-form-label col-form-label-sm">Sale Price (₹)</label>
                    <div class="col-md-8">
                      <input type="number" class="form-control form-control-sm" formControlName="salePrice"
                        [class.is-invalid]="(priceSection.get('salePrice')?.touched && priceSection.get('salePrice')?.invalid) || wrongDiscount"
                        (blur)="discountPriceChange()" (input)="discountPriceChange()">
                      @if (priceSection.get('salePrice')?.touched && priceSection.get('salePrice')?.errors?.['min']) {
                      <div class="text-danger fs-12 mt-1">
                        Discount cannot be negative.
                      </div>
                      }
                      @if (priceSection.get('salePrice')?.touched && priceSection.get('salePrice')?.errors?.['max']) {
                      <div class="text-danger fs-12 mt-1">
                        Discount percentage cannot exceed 100%.
                      </div>
                      }
                      @if (wrongDiscount) {
                      <div class="text-danger fs-12 mt-1">
                        Discount must be less than Regular Price.
                      </div>
                      }
                    </div>
                    <!-- <div class="col-md-2">
                      <div class="form-control-sm p-0">
                        <select class="form-control form-control-sm" formControlName="discountType"
                          (change)="onDiscountTypeChange()">
                          <option value="Flat">Flat</option>
                          <option value="Discount">Discount</option>
                        </select>
                      </div>
                    </div> -->
                  </div>
                  <div class="row g-3 mb-3">
                    <label for="gst" class="col-md-2 col-form-label col-form-label-sm">Gst (%)</label>
                    <div class="col-md-8">
                      <input type="number" class="form-control form-control-sm" formControlName="gstPercent"
                        [class.is-invalid]="(priceSection.get('gstPercent')?.touched && priceSection.get('gstPercent')?.invalid)"
                        (blur)="discountPriceChange()" (input)="discountPriceChange()">
                      <!-- @if (priceSection.get('salePrice')?.touched && priceSection.get('salePrice')?.errors?.['min']) {
                      <div class="text-danger fs-12 mt-1">
                        Discount cannot be negative.
                      </div>
                      }
                      @if (priceSection.get('salePrice')?.touched && priceSection.get('salePrice')?.errors?.['max']) {
                      <div class="text-danger fs-12 mt-1">
                        Discount percentage cannot exceed 100%.
                      </div>
                      }
                      @if (wrongDiscount) {
                      <div class="text-danger fs-12 mt-1">
                        Discount must be less than Regular Price.
                      </div>
                      } -->
                    </div>
                    <!-- <div class="col-md-2">
                      <div class="form-control-sm p-0">
                        <select class="form-control form-control-sm" formControlName="discountType"
                          (change)="onDiscountTypeChange()">
                          <option value="Flat">Flat</option>
                          <option value="Discount">Discount</option>
                        </select>
                      </div>
                    </div> -->
                  </div>
                  @if(false) {
                  <div class="row g-3">
                    <label for="PriceDateStart" class="col-md-2 col-form-label col-form-label-sm">Sale price
                      dates</label>
                    <div class="col-md-5">
                      <input type="datetime-local" class="form-control form-control-sm"
                        formControlName="priceDateStart" />
                    </div>
                    <div class="col-md-5">
                      <input type="datetime-local" class="form-control form-control-sm" formControlName="priceDateEnd"
                        placeholder="DD MMMM YYYY - HH:MM">
                    </div>
                  </div>
                  }
                </form>
              </div>

              <!-- Shipping Info Tab -->
              <div class="tab-pane fade" id="nav-shipping-info" role="tabpanel" aria-labelledby="nav-shipping-info-tab"
                tabindex="0">
                <form [formGroup]="shippingInfoSection">
                  <div class="row g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Weight (g) <span class="btn-flush fs-14"
                        data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <input type="number" class="form-control form-control-sm" formControlName="weight" id="weight"
                        placeholder="0">
                    </div>
                  </div>
                  <div class="row g-3 mb-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Dimensions (cm) <span
                        class="btn-flush fs-14" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <div class="row g-3">
                        <div class="col-md-4">
                          <input type="number" class="form-control form-control-sm" formControlName="length"
                            id="Dimensions" placeholder="Length">
                        </div>
                        <div class="col-md-4">
                          <input type="number" class="form-control form-control-sm" formControlName="width"
                            placeholder="Width">
                        </div>
                        <div class="col-md-4">
                          <input type="number" class="form-control form-control-sm" formControlName="height"
                            placeholder="Height">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row g-3">
                    <label class="col-md-2 col-form-label col-form-label-sm">Shipping Class <span
                        class="btn-flush fs-14" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                        data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry."><i
                          class="fa-solid fa-circle-question"></i></span></label>
                    <div class="col-md-10">
                      <select class="form-control form-control-sm" formControlName="shippingClass">
                        <option value="0">No Shipping Class</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Other Tabs (Unmodified for brevity) -->
              <div class="tab-pane fade" id="nav-attribute" role="tabpanel" aria-labelledby="nav-attribute-tab"
                tabindex="0">
                <!-- <div class="product-type-selector mb-4 p-3 bg-light rounded border">
                  <label class="form-label fw-bold mb-2">Product Type</label>
                  <div class="d-flex gap-3">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="productType" id="typeSimple" value="simple" [(ngModel)]="productType" [ngModelOptions]="{standalone: true}">
                      <label class="form-check-label" for="typeSimple">Simple Product</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="productType" id="typeVariable" value="variable" [(ngModel)]="productType" [ngModelOptions]="{standalone: true}">
                      <label class="form-check-label" for="typeVariable">Variable Product</label>
                    </div>
                  </div>
                </div> -->

                @if (productType === 'variable') {
                  <!-- STEP 1: Select Attributes & Values -->
                  <div class="attribute-selection-container p-4 border rounded mb-4 bg-white shadow-sm">
                    <h6 class="border-bottom pb-2 mb-3"><span class="badge bg-primary me-2">STEP 1</span> Select Attributes & Values</h6>
                    
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Select Variant Attributes</label>
                      <div class="d-flex flex-wrap gap-3 attribute-checkbox-list">
                        @for (attr of allAttributes; track attr.id) {
                          <div class="form-check attribute-checkbox-item">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'attr-top-' + attr.id"
                              [checked]="isAttributeSelected(attr.id)"
                              (change)="toggleAttributeSelection(attr)">
                            <label class="form-check-label fw-medium" [for]="'attr-top-' + attr.id">
                              {{ attr.name }}
                            </label>
                          </div>
                        }
                      </div>
                    </div>

                    @if (selectedAttributesForVariations.length > 0) {
                      <div class="attributes-master-list">
                        @for (attr of selectedAttributesForVariations; track attr.attribute_id) {
                          <div class="attribute-row mb-3 p-3 border rounded-3 bg-light-subtle">
                            <div class="fw-bold mb-2">{{ attr.name }}</div>
                            <div class="values-grid d-flex flex-wrap gap-3">
                              @for (val of (attr.values || []); track val.id) {
                                <div class="form-check value-item">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    [id]="'val-' + attr.attribute_id + '-' + val.id"
                                    [checked]="isValueSelected(attr.attribute_id, val.id)"
                                    (change)="toggleValueSelection(attr.attribute_id, val.id)">
                                  <label class="form-check-label" [for]="'val-' + attr.attribute_id + '-' + val.id">
                                    {{ val.value }}
                                    @if (attr.type === 'color' || attr.type === 'color_swatch') {
                                      <span class="ms-1 border rounded-circle d-inline-block"
                                            [style.background-color]="val.meta" style="width: 12px; height: 12px;"></span>
                                    }
                                  </label>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <p class="text-muted mb-0">Select at least one attribute to view its values.</p>
                    }

                    @if (hasSelectedVariationValues()) {
                      <div class="text-center mt-4 pt-3 border-top">
                        <button type="button" class="btn btn-primary px-5 py-2 shadow-sm" (click)="generateVariations()">
                          Preview Combinations
                        </button>
                      </div>
                    } @else if (hasIncompleteAttributeSelections()) {
                      <div class="mt-3 pt-3 border-top">
                        <small class="text-muted">
                          Select at least one value for each selected attribute
                          @if (getIncompleteAttributeNames()) {
                            ({{ getIncompleteAttributeNames() }}).
                          } @else {
                            .
                          }
                        </small>
                      </div>
                    }

                    @if (showVariantTable) {
                      <div class="variants-preview-container mt-4 pt-3 border-top">
                        <h6 class="mb-3">Preview Combinations</h6>
                        <div class="table-responsive">
                          <table class="table table-hover align-middle">
                            <thead class="bg-light">
                              <tr>
                                <th>Variant (SKU)</th>
                                <!-- @if (shouldShowVariantImageColumn()) { -->
                                  <th style="width: 260px;">Upload Image</th>
                                <!-- } -->
                                <th style="width: 180px;">Sales Price</th>
                                <th style="width: 120px;">Stock</th>
                                <th style="width: 120px;">Status</th>
                                <th style="width: 50px;">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (variantCtrl of variantsFormArray.controls; track $index) {
                                <tr [formGroup]="$any(variantCtrl)">
                                  <td>
                                    <div class="fw-bold">
                                      {{ getVariantDisplayName(variantCtrl, $index) }}
                                    </div>
                                    @if (variantCtrl.get('sku_suffix')?.value) {
                                      <small class="text-muted">({{ variantCtrl.get('sku_suffix')?.value }})</small>
                                    }
                                  </td>
                                  <!-- @if (shouldShowVariantImageColumn()) { -->
                                    <td>
                                      <!-- @if (variantHasColorAttribute(variantCtrl)) { -->
                                        <div class="d-flex align-items-start gap-2">
                                          <div class="variant-image-thumb border rounded bg-light d-flex align-items-center justify-content-center overflow-hidden">
                                            @if (variantCtrl.get('image_preview_url')?.value) {
                                              <img
                                                [src]="variantCtrl.get('image_preview_url')?.value"
                                                alt="Variant image preview"
                                                class="w-100 h-100 object-fit-cover">
                                            } @else if (variantCtrl.get('image_id')?.value) {
                                              <span class="small fw-semibold text-primary">#{{ variantCtrl.get('image_id')?.value }}</span>
                                            } @else {
                                              <i class="fa fa-image text-muted"></i>
                                            }
                                          </div>
                                          <div class="flex-grow-1">
                                            <input
                                              type="file"
                                              class="form-control form-control-sm"
                                              accept="image/*"
                                              [disabled]="isVariantImageUploading($index)"
                                              (change)="onVariantImageSelected($event, $index)">
                                            @if (isVariantImageUploading($index)) {
                                              <small class="text-muted d-block mt-1">Uploading image...</small>
                                            } @else if (variantCtrl.get('image_id')?.value) {
                                              <small class="text-success d-block mt-1">Media ID: {{ variantCtrl.get('image_id')?.value }}</small>
                                            } @else {
                                              <small class="text-muted d-block mt-1">Upload a color-specific image</small>
                                            }
                                          </div>
                                        </div>
                                      <!-- } @else {
                                        <small class="text-muted">Not required</small>
                                      } -->
                                    </td>
                                  <!-- } -->
                                  <td>
                                    <input type="number" class="form-control" formControlName="price">
                                  </td>
                                  <td>
                                    <input type="number" class="form-control" formControlName="stock">
                                  </td>
                                  <td>
                                    <div class="form-check form-switch">
                                      <input class="form-check-input" type="checkbox" formControlName="is_active">
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <button type="button" class="btn btn-link text-danger p-0" (click)="removeVariantAt($index)">
                                      <i class="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                  </div>

                  @if (false) {
                  <!-- STEP 2: Manage Generated Variants (Legacy - kept hidden for future use) -->
                  @if (variableCombinations.length > 0) {
                    <div class="variants-management-container p-4 border rounded bg-white shadow-sm">
                      <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                        <h6 class="mb-0"><span class="badge bg-success me-2">STEP 2</span> Manage Generated Variants</h6>
                        <div class="base-price-info">
                          <span class="text-muted small">Base Price: </span>
                          <span class="fw-bold text-primary">₹{{ priceSection.get('regularPrice')?.value || 0 }}</span>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <table class="table table-hover align-middle">
                          <thead class="bg-light">
                            <tr>
                              <th style="width: 80px;">Image</th>
                              <th>Variant (SKU)</th>
                              <th style="width: 180px;">Override Price</th>
                              <th style="width: 120px;">Stock</th>
                              <th style="width: 100px;">Status</th>
                              <th style="width: 50px;">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (row of variableCombinations; track $index) {
                              <tr>
                                <td>
                                  <div class="variant-img-placeholder border rounded d-flex align-items-center justify-content-center bg-light" 
                                       style="width: 50px; height: 50px; cursor: pointer;">
                                    <i class="fa fa-image text-muted"></i>
                                  </div>
                                </td>
                                <td>
                                  <div class="fw-bold">{{ row.variant_name }}</div>
                                  <div class="input-group input-group-sm mt-1" style="max-width: 150px;">
                                    <span class="input-group-text bg-white"><i class="fa fa-barcode small"></i></span>
                                    <input type="text" class="form-control" placeholder="SKU Suffix" 
                                           [(ngModel)]="row.sku_suffix" [ngModelOptions]="{standalone: true}">
                                  </div>
                                </td>
                                <td>
                                  <div class="input-group">
                                    <span class="input-group-text bg-white">₹</span>
                                    <input type="number" class="form-control" 
                                           [placeholder]="priceSection.get('regularPrice')?.value || '0.00'"
                                           [(ngModel)]="row.price" [ngModelOptions]="{standalone: true}">
                                  </div>
                                  @if (!row.price) {
                                    <small class="text-muted italic">Using base price</small>
                                  }
                                </td>
                                <td>
                                  <input type="number" class="form-control" [(ngModel)]="row.stock" [ngModelOptions]="{standalone: true}">
                                </td>
                                <td>
                                  <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="row.is_active" [ngModelOptions]="{standalone: true}">
                                    <span class="badge" [ngClass]="row.is_active ? 'bg-success' : 'bg-secondary'">
                                      {{ row.is_active ? 'ON' : 'OFF' }}
                                    </span>
                                  </div>
                                </td>
                                <td class="text-center">
                                  <button type="button" class="btn btn-link text-danger p-0" (click)="variableCombinations.splice($index, 1)">
                                    <i class="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  } @else {
                    <div class="text-center py-5 bg-light rounded border border-dashed">
                      <i class="fa fa-layer-group fa-3x text-muted mb-3"></i>
                      <p class="text-muted">Select attributes above and click "Generate" to manage variants.</p>
                    </div>
                  }
                  }
                } @else {
                  <div class="text-center py-5 bg-light rounded border border-dashed">
                    <i class="fa fa-box fa-3x text-muted mb-3"></i>
                    <h5>Simple Product Mode</h5>
                    <p class="text-muted">Standard product with no variations. Prices and stock are managed in the General/Inventory tabs.</p>
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="productType = 'variable'">
                      Switch to Variable Product
                    </button>
                  </div>
                }
              </div>

              <!-- video section  -->
              <div class="tab-pane fade" id="nav-video" role="tabpanel" aria-labelledby="nav-video-tab" tabindex="0">
                <div class="row align-items-center g-3 mb-3">
                  <label class="col-md-2 col-form-label col-form-label-sm">Video Provider</label>
                  <div class="col-md-10">
                    <select class="form-control form-control-sm" data-placeholder="Select Provider">
                      <option value="">Select Provider</option>
                      <option value="0">Youtube</option>
                      <option value="1">Vimeo</option>
                    </select>
                  </div>
                </div>
                <div class="row g-3">
                  <label class="col-md-2 col-form-label col-form-label-sm">Video Link</label>
                  <div class="col-md-10">
                    <input type="url" class="form-control form-control-sm" name="video_link" placeholder="Video Link">
                    <span class="input-additional-txt">Use proper link without extra parameter. Don't use short share
                      link/embeded iframe code.</span>
                  </div>
                </div>
              </div>

              <!-- shipping configuration  -->
              <div class="tab-pane fade" id="nav-shipping-configuration" role="tabpanel"
                aria-labelledby="nav-shipping-configuration-tab" tabindex="0">
                <form [formGroup]="shippingConfigForm">
                  <div class="row align-items-center g-3 mb-3">
                    <label for="estimateShippingTime" class="col-md-2 col-form-label col-form-label-sm">Estimate
                      Shipping Time</label>
                    <div class="col-md-10">
                      <div class="input-group">
                        <input type="number" formControlName="estimateShippingTime" class="form-control form-control-sm"
                          id="estimateShippingTime">
                        <span class="input-group-text">Days</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row align-items-center g-3 mb-3">
                    <label for="freeShipping" class="col-md-2 col-8 col-form-label col-form-label-sm">Free
                      Shipping</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" formControlName="freeShipping" type="checkbox" role="switch"
                          id="freeShipping">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label for="flatRate" class="col-md-2 col-8 col-form-label col-form-label-sm">Flat Rate</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" formControlName="flatRate"
                          id="flatRate">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label for="QuantityMulitiply" class="col-md-2 col-8 col-form-label col-form-label-sm">Quantity
                      Mulitiply</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch"
                          formControlName="quantityMulitiply" id="QuantityMulitiply">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3">
                    <label for="cashOnDelivery" class="col-md-2 col-8 col-form-label col-form-label-sm">Cash On
                      Delivery</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" formControlName="cashOnDelivery"
                          id="cashOnDelivery">
                      </div>
                    </div>
                  </div> -->
                </form>
              </div>

              <!-- offer  -->
              <div class="tab-pane fade" id="nav-offer" role="tabpanel" aria-labelledby="nav-offer-tab" tabindex="0">
                <form [formGroup]="offerForm">
                  <div class="row align-items-center g-3 mb-3">
                    <label for="flashDeal" class="col-md-2 col-8 col-form-label col-form-label-sm">Flash Deal</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" formControlName="flashDeal"
                          id="flashDeal">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3 mb-3">
                    <label for="todaysDeal" class="col-md-2 col-8 col-form-label col-form-label-sm">Today's Deal</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" formControlName="todaysDeal"
                          id="todaysDeal">
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center g-3">
                    <label for="featured" class="col-md-2 col-8 col-form-label col-form-label-sm">Featured</label>
                    <div class="col-md-10 col-4">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" formControlName="featured"
                          id="featured">
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>

          <div class="panel">
            <form [formGroup]="seoForm">
              <div class="panel-header">
                <h5>SEO Data</h5>
                <div class="btn-box d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-icon btn-outline-primary">
                    <i class="fa fa-arrows-rotate"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-icon btn-outline-primary panel-close">
                    <i class="fa fa-angle-up"></i>
                  </button>
                </div>
              </div>
              <div class="panel-body">
                <div class="row g-3 mb-3">
                  <label class="col-xxl-2 col-md-3 col-form-label col-form-label-sm pe-0">Focus keyphrase <span
                      class="btn-flush fs-14" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
                      data-bs-title="Lorem Ipsum is simply dummy text of the printing and typesetting industry.">
                      <i class="fa-solid fa-circle-question"></i>
                    </span></label>
                  <div class="col-xxl-10 col-md-9">
                    <input type="text" class="form-control form-control-sm" id="focusKeyphrase"
                      formControlName="focusKeyphrase">
                  </div>
                </div>
                <div class="row g-3 mb-3">
                  <label for="metaTitle" class="col-xxl-2 col-md-3 col-form-label col-form-label-sm">Meta Title</label>
                  <div class="col-xxl-10 col-md-9">
                    <input type="text" class="form-control form-control-sm" id="metaTitle" formControlName="metaTitle">
                  </div>
                </div>
                <div class="row g-3">
                  <label for="metaDscr" class="col-xxl-2 col-md-3 col-form-label col-form-label-sm">Meta
                    Description</label>
                  <div class="col-xxl-10 col-md-9">
                    <textarea class="form-control" rows="5" id="metaDscr" formControlName="metaDscr"></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-xxl-3 col-lg-4">
        <div class="position-sticky top-0 z-3 w-100 bg-white mb-30">
          @if (!this.isUpdateproduct || this.data.mode == 'new' || this.data.mode == 'clone') {
          <a type="button" class="btn btn-primary d-block" (click)="confirmBeforeSaveProduct('add')">Publish</a>
          }

          @if (this.isUpdateproduct && this.data.mode == 'update') {
          <a type="button" class="btn btn-primary d-block" (click)="confirmBeforeSaveProduct('update')">Update</a>
          }

        </div>
        <div class="add-product-sidebar">
          @if(false){
          <div class="panel mb-30">
            <div class="panel-header">
              <h5>Published</h5>
              <div class="btn-box d-flex gap-2">
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary"><i
                    class="fa fa-arrows-rotate"></i></button>
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary panel-close"><i
                    class="fa fa-angle-up"></i></button>
              </div>
            </div>
            <div class="panel-body">
              <div class="row g-3">
                <div class="col-6">
                  <label class="form-label">Status</label>
                  <select class="form-control form-control-sm" formControlName="status">
                    <option value="0">Published</option>
                    <option value="1">Draft</option>
                  </select>
                </div>
                <div class="col-6">
                  <label class="form-label">Visibility</label>
                  <select class="form-control form-control-sm" formControlName="visibility">
                    <option value="0">Public</option>
                    <option value="1">Pass. Protected</option>
                    <option value="2">Private</option>
                  </select>
                </div>
                <div class="col-12">
                  <div class="publish-date">
                    <label>Published on: </label>
                    <input class="input-flush" type="date" id="publishDate" formControlName="publishDate">
                    <label for="publishDate" class="cursor-pointer text-primary"><i
                        class="fa fa-pen-to-square"></i></label>
                  </div>
                  <!-- <div class="publish-date">
                        <label>Published on: </label>
                        <input class="input-flush" type="datetime-local" id="publishDate" formControlName="publishDate">
                        <label for="publishDate" class="cursor-pointer text-primary"><i class="fa fa-pen-to-square"></i></label>
                      </div> -->
                </div>
              </div>
            </div>
          </div>
          }
          <div class="panel mb-30">
            <div class="panel-header">
              <h5>Category</h5>
              <div class="btn-box d-flex gap-2">
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary">
                  <i class="fa fa-arrows-rotate"></i>
                </button>
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary panel-close">
                  <i class="fa fa-angle-up"></i>
                </button>
              </div>
            </div>

            <app-category-tree [categoriesData]="categoryListData" (selectedId)="onGetId($event)"></app-category-tree>
          </div>
          <!-- ✅ wrap everything under one form group -->
          <!-- <div class="panel-body" [formGroup]="categoryForm"> -->
          <!-- Search Form -->
          <!-- <form (ngSubmit)="onSearch()" class="input-group-with-icon mb-20">
                    <span class="input-icon">
                      <i class="fa fa-magnifying-glass"></i>
                    </span>
                    <input
                      type="search"
                      formControlName="search"
                      placeholder="Search category"
                      class="form-control"
                    />
                  </form> -->

          <!-- Category Checkboxes -->
          <!-- <div class="product-categories" formArrayName="selectedCategories">
                    @for (control of selectedCategories.controls; track $index) {
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [formControlName]="$index"
                          id="category-{{$index}}"
                        />
                        <label class="form-check-label" for="category-{{$index}}">
                          {{ getCategoryLabel($index) }}
                        </label>
                      </div>
                    }
                  </div> -->

          <!-- ✅ Visual divider -->
          <!-- <div class="border-top mt-3 mb-3"></div> -->

          <!-- Add New Category -->
          <!-- <div class="d-flex justify-content-end">
                    <button type="button" class="btn-flush add-category-btn">
                      <i class="fa fa-plus"></i> Add new category
                    </button>
                  </div> -->

          <!-- ✅ Correctly nested child form group -->
          <!-- <div class="add-new-category-panel mt-3" formGroupName="newCategory">
                    <input
                      type="text"
                      class="form-control form-control-sm mb-3"
                      formControlName="name"
                      placeholder="Category Name"
                    />
                    <select
                      class="form-control form-control-sm mb-3"
                      formControlName="parent"
                      data-placeholder="Select Parent"
                    >
                      <option value="">Select Parent</option>
                      @for (category of categories; track $index) {
                        <option [value]="category.name">{{ category.name }}</option>
                      }
                    </select>
  
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        (click)="addNewCategory()"
                      >
                        Update
                      </button>
                    </div>
                  </div> -->

          <!-- </div> -->
          <!-- </div> -->

          @if(tagsForm){
          <div class="panel" [formGroup]="tagsForm">
            <div class="panel-header">
              <h5>Products Tags</h5>
              <div class="btn-box d-flex gap-2">
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary">
                  <i class="fa fa-arrows-rotate"></i>
                </button>
                <button type="button" class="btn btn-sm btn-icon btn-outline-primary panel-close">
                  <i class="fa fa-angle-up"></i>
                </button>
              </div>
            </div>

            <div class="panel-body">
              <div class="product-tag-area">
                <!-- <form > -->
                <div class="row g-3">
                  <div class="col-9">
                    <input type="text" class="input-flush form-control" id="productTags" placeholder="Enter tags"
                      formControlName="tagInput" />
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-sm btn-primary w-100" (click)="addTag()">
                      Add
                    </button>
                  </div>
                </div>
                <!-- </form> -->

                <span class="input-txt">Use commas to separate tags</span>

                <!-- Added tags -->
                <div class="all-tags mt-2">
                  @for (tag of tagsForm.value.tags; track $index) {
                  <div class="item d-inline-block">
                    {{ tag }}
                    <span class="close-tag" (click)="removeTag($index)">
                      <i class="fa fa-xmark"></i>
                    </span>
                  </div>
                  }
                </div>

                <!-- Tag History -->
                <div class="tag-history mt-3">
                  <span class="choose-used-tag input-txt">Choose from most used tags</span>
                  <div class="all-tags used-tags active">
                    @for (tag of commonTags; track $index) {
                    <div class="item d-inline-block" (click)="selectTag(tag)">
                      {{ tag }}
                      <span class="close-tag">
                        <i class="fa fa-xmark"></i>
                      </span>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- footer start -->
    <!-- <div class="footer">
      <p>Copyright©
        <script>document.write(new Date().getFullYear())</script> All Rights Reserved By <span
          class="text-primary">safure</span>
      </p>
    </div> -->
    <!-- footer end -->
  </form>
</div>
<!-- main content end -->

<ng-template #elementorModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Visual Builder - {{ currentEditingField }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    @if (currentEditingField) {
      <app-elementor-editor
        [(ngModel)]="tempElementorValue"
        [ngModelOptions]="{standalone: true}"
        [uploadFn]="handleImageUpload">
      </app-elementor-editor>
    }
  </div>
  <div class="modal-footer gap-2">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="modal.close('save')">Done</button>
  </div>
</ng-template>

<!-- VARIANT GENERATOR MODAL -->
<ng-template #variantModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">Variant Generator Engine</h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body bg-light">
    <div class="variation-generator-engine">
      <div class="panel p-3 mb-4 shadow-sm border-0">
        <h6 class="border-bottom pb-2 mb-3">1. Select Attributes & Values</h6>
        <div class="row g-3">
          @for (attr of allAttributes; track attr.id) {
            <div class="col-md-4">
              <div class="card h-100 border-0 shadow-sm">
                <div class="card-header py-2 d-flex justify-content-between align-items-center bg-white border-bottom-0">
                  <span class="fw-bold">{{ attr.name }}</span>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [checked]="isAttributeSelected(attr.id)" (change)="toggleAttributeSelection(attr)">
                  </div>
                </div>
                @if (isAttributeSelected(attr.id)) {
                  <div class="card-body py-2">
                    <div class="d-flex flex-wrap gap-2">
                      @for (val of attr.values; track val.id) {
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" 
                            [checked]="isValueSelected(attr.id, val.id)" 
                            (change)="toggleValueSelection(attr.id, val.id)"
                            id="val-{{val.id}}">
                          <label class="form-check-label fs-12" for="val-{{val.id}}">{{ val.value }}</label>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="mt-4 text-center">
          <button type="button" class="btn btn-primary px-4" (click)="generateVariations()">
            <i class="fa fa-magic me-2"></i> Generate Combinations Matrix
          </button>
        </div>
      </div>

      @if (variableCombinations.length > 0) {
        <div class="variations-table-container mt-4 bg-white p-3 rounded shadow-sm">
          <h6 class="border-bottom pb-2 mb-3">2. Manage Variants Matrix</h6>
          <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
            <table class="table table-bordered table-sm align-middle mb-0">
              <thead class="bg-light sticky-top">
                <tr>
                  <th>Variant Name</th>
                  <th>SKU Suffix</th>
                  <th style="width: 150px;">Price (₹)</th>
                  <th style="width: 150px;">Stock</th>
                  <th style="width: 50px;">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (row of variableCombinations; track $index) {
                  <tr>
                    <td class="fw-medium">{{ row.variant_name }}</td>
                    <td>
                      <input type="text" class="form-control form-control-sm" [(ngModel)]="row.sku_suffix" [ngModelOptions]="{standalone: true}">
                    </td>
                    <td>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text">₹</span>
                        <input type="number" class="form-control" [(ngModel)]="row.price" [ngModelOptions]="{standalone: true}">
                      </div>
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="row.stock" [ngModelOptions]="{standalone: true}">
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-link text-danger p-0" (click)="variableCombinations.splice($index, 1)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      } @else {
        <div class="text-center py-5 bg-white rounded shadow-sm mt-4">
          <i class="fa fa-table-list fa-3x text-muted mb-3"></i>
          <p class="text-muted">No variations generated yet. Select attributes above and click "Generate".</p>
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close & Save Progress</button>
    <button type="button" class="btn btn-success" (click)="modal.close()">Done</button>
  </div>
</ng-template>
